/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import {
    AfterViewInit,
    ComponentRef,
    DestroyRef,
    Directive,
    HostBinding,
    Input,
    OnChanges,
    Renderer2,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';

import { SimpleCallback } from '@frontend/sports/common/core/utils/extended-types';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { INPUT_END } from 'hammerjs';

import { SwipeActionsComponent } from './swipe-actions.component';

interface SwipeContext<T> {
    $implicit: T;
    close: Function;
    open: Function;
}

@Directive({
    selector: '[msSwipeActions]',
    standalone: false,
})
export class SwipeActionsDirective implements OnChanges, AfterViewInit {
    static SWIPE_CLASS = 'swiped';
    static SWIPE_ATTR = 'swipeable';
    static SWIPE_TIME = 250;

    @Input('msSwipeActions') template: TemplateRef<any>;
    @Input() swipeContext: any;
    @HostBinding('attr.swipeable') attribute = true;

    private swiped = false;
    private transformTimeout: any;
    private timeout?: SimpleCallback;
    private component?: ComponentRef<SwipeActionsComponent>;
    private get node(): HTMLElement {
        return this.view.element.nativeElement;
    }

    constructor(
        private renderer: Renderer2,
        private view: ViewContainerRef,
        private timer: TimerService,
        private destroyRef: DestroyRef,
    ) {
        this.destroyRef.onDestroy(() => {
            this.view.clear();
        });
    }

    ngAfterViewInit(): void {
        this.setTransition(this.node.firstElementChild);
        this.setTransform(this.node.firstElementChild, 0);
    }

    ngOnChanges(changes: ISimpleChanges<SwipeActionsDirective>): void {
        if (changes.swipeContext && this.swiped && this.component) {
            this.component.instance.context = this.context;
        }
    }

    open(positionX?: number, swipeEndThreshold?: number, eventType?: number): void {
        this.swipe(true, positionX, swipeEndThreshold, eventType);
    }

    close(): void {
        this.swipe(false);
    }

    private swipe(swiped: boolean, positionX?: number, swipeEndThreshold?: number, eventType?: number): void {
        if (swiped === this.swiped) {
            return;
        }

        if (swiped) {
            this.timeout?.();

            if (!this.component || this.component.instance?.isComponentDestroyed) {
                this.component = this.view.createComponent(SwipeActionsComponent);
                this.component.instance.template = this.template;
                this.component.instance.context = this.context;
                this.component.hostView.detectChanges();
            }

            const actions: HTMLElement = this.component.location.nativeElement;

            this.setTransition(actions);
            this.setTransform(actions, 0);

            this.renderer.insertBefore(this.node, actions, this.node.firstElementChild);
            this.renderer.addClass(this.node, SwipeActionsDirective.SWIPE_CLASS);

            if (this.transformTimeout) clearTimeout(this.transformTimeout);
            if ((positionX || positionX === 0) && swipeEndThreshold) {
                this.setTransition(actions, 5);
                if (positionX >= 0) this.setTransform(actions, positionX);
                if (positionX < swipeEndThreshold) {
                    this.transformTimeout = setTimeout(() => {
                        if (eventType === INPUT_END) {
                            this.setTransition(actions, 250);
                            this.setTransform(actions, 0);
                        }
                    }, 100);
                } else {
                    this.setTransform(actions, actions.offsetWidth);
                    this.swiped = true;
                }
            } else {
                this.setTransform(actions, actions.offsetWidth);
                this.swiped = true;
            }
        } else if (this.component) {
            const actions: HTMLElement = this.component.location.nativeElement;

            this.timeout = this.timer.setTimeout(() => {
                if (this.component) {
                    this.renderer.removeChild(this.node, actions);
                    this.component.destroy();
                }

                this.swiped = false;
            }, SwipeActionsDirective.SWIPE_TIME);

            this.renderer.removeClass(this.node, SwipeActionsDirective.SWIPE_CLASS);

            this.setTransform(actions, 0);
        }
    }

    private get context(): SwipeContext<any> {
        return { $implicit: this.swipeContext, open: this.open.bind(this), close: this.close.bind(this) };
    }

    private setTransform(start: Element | null, position: number): void {
        this.setStyle(start, 'transform', `translateX(${position}px)`);
    }

    private setTransition(start: Element | null, swipeTransitionTime?: number): void {
        const swipeTime = swipeTransitionTime ? swipeTransitionTime : SwipeActionsDirective.SWIPE_TIME;
        this.setStyle(start, 'transition', `transform ${swipeTime}ms ease-in-out`);
    }

    private setStyle(start: Element | null, style: string, value: string): void {
        let child = start;

        while (child) {
            this.renderer.setStyle(child, style, value);
            child = child.nextElementSibling;
        }
    }
}
